import { CaseState, ViewMode } from 'app/area/case/types-store';
import { ConnectedComponentProps } from 'app/infrastructure/ui/types-uischema';
import { RenderMode } from 'app/types-shared';

export const editDetailsActionOverride = (caseState: CaseState, uiEngineProps: ConnectedComponentProps) => {
  const {
    showDetailsEditButton
  } = uiEngineProps.componentDescriptor.properties;
  const { renderMode, editing } = caseState;

  return {
    shouldEditDocumentItem: !editing && caseState.viewMode === ViewMode.tabs,
    shouldHideEditDocumentIcon: showDetailsEditButton && 
      renderMode === RenderMode.read && 
      !uiEngineProps.enabledEntityOperations?.edit
  };
};
